import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import { queryClient } from '@core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { TContactInfoValues } from '../components/edit-user/constants';

export const editUserContactInfo = async ({
  userId,
  ...data
}: TContactInfoValues & { userId: number; id: number }) => {
  const id = data.id;
  return await request({
    url: id
      ? `members/${userId}/contact-info/${data.id}`
      : `members/${userId}/contact-info/`,
    method: id ? 'PATCH' : 'POST',
    body: data,
  });
};

export const useEditUserContactInfo = () => {
  return useMutation({
    mutationFn: editUserContactInfo,
    onError: (error: string) => {
      toast.error(error);
    },
    onSuccess: () => {
      toast.success('User Contact Info has updated successfully.');
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.getUserById],
      });
    },
  });
};
